export const fallbackUsername = (uid: string, email?: string | null): string => {
  const prefix = (email?.split('@')[0] || '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 20);
  const uidSuffix = uid.toLowerCase().replace(/[^a-z0-9]/g, '').slice(-6) || 'member';
  return `${prefix || 'user'}_${uidSuffix}`;
};
